export const getInitials = (name: string, maxLength: number = 2) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, maxLength);
};
